import React, { Component } from "react";
import CssClasses from "./LayoutAdmin.css";

import { connect } from "react-redux";

import AdminHeader from "../../Containers/AdminScreens/AdminHeader/AdminHeader";
import AdminFooter from "../../Containers/AdminScreens/AdminFooter/AdminFooter";
import AdminSideMenu from "../../Components/Navigation/AdminSideMenu/AdminSideMenu";

import Balance from "../../Containers/AdminScreens/Balance/Balance";
import BillFlow from "../../Containers/AdminScreens/BillFlow/BillFlow";
import Preferences from "../../Containers/AdminScreens/Preferences/Preferences";
import QRCodes from "../../Containers/AdminScreens/QRCodes/QRCodes";
import Tickets from "../../Containers/AdminScreens/Tickets/Tickets";
import Transactions from "../../Containers/AdminScreens/Transactions/Transactions";
import Dashboard from "../../Containers/AdminScreens/Dashboard/Dashboard";
import PartialPayoutReceipts from "../../Containers/AdminScreens/PartialPayoutReceipts/PartialPayoutReceipts";
import FindTicket from "../../Containers/AdminScreens/FindTicket/FindTicket";
import EventLog from "../../Containers/AdminScreens/EventLog/EventLog";
import FullscreenModalPopup from "../../Components/UI/FullscreenModalPopup/FullscreenModalPopup";

import * as AdminScreens from "../Constants/AdminScreenIDs";

import CefMonitor from "../CefMonitor/CefMonitor";

class LayoutAdmin extends Component {
  state = {
    infoMessage: ""
  };

  render() {
    return (
      <div className={CssClasses.container}>
        <FullscreenModalPopup
          message={this.state.infoMessage}
          btnOkClickCallback={this.modalPopupBtnOk_Callback}
        />

        <div className={CssClasses.header}>
          <AdminHeader />
        </div>

        <div className={CssClasses.sideMenu}>
          <AdminSideMenu />
        </div>

        <div className={CssClasses.mainContent}>
          <div className={CssClasses.titleSection}>
            ADMIN > {this.getPageTitle()}
          </div>

          {this.props.currentAdminScreenID ===
          AdminScreens.ADMIN_SCREEN_TERMINAL_BALANCE ? (
            <Balance />
          ) : null}

          {this.props.currentAdminScreenID ===
          AdminScreens.ADMIN_SCREEN_BILL_FLOW ? (
            <BillFlow />
          ) : null}

          {this.props.currentAdminScreenID ===
          AdminScreens.ADMIN_SCREEN_QR_CODES ? (
            <QRCodes />
          ) : null}

          {this.props.currentAdminScreenID ===
          AdminScreens.ADMIN_SCREEN_SETTINGS ? (
            <Preferences setPopupMessage={msg => this.setPopupMessage(msg)} />
          ) : null}

          {this.props.currentAdminScreenID ===
          AdminScreens.ADMIN_SCREEN_TICKET_OVERVIEW ? (
            <Tickets />
          ) : null}

          {this.props.currentAdminScreenID ===
          AdminScreens.ADMIN_SCREEN_TRANSACTIONS ? (
            <Transactions />
          ) : null}

          {this.props.currentAdminScreenID ===
          AdminScreens.ADMIN_SCREEN_DASHBOARD ? (
            <Dashboard />
          ) : null}

          {this.props.currentAdminScreenID ===
          AdminScreens.ADMIN_SCREEN_EVENT_LOG ? (
            <EventLog />
          ) : null}

          {this.props.currentAdminScreenID ===
          AdminScreens.ADMIN_SCREEN_PARTIAL_PAYOUT_RECEIPTS ? (
            <PartialPayoutReceipts />
          ) : null}

          {this.props.currentAdminScreenID ===
          AdminScreens.ADMIN_SCREEN_FIND_TICKET ? (
            <FindTicket />
          ) : null}
        </div>

        <AdminFooter />
        <CefMonitor />

        {this.props.isAdminLoadingShown ? (
          <div className={CssClasses.loader} id="loader">
            Loading...
          </div>
        ) : null}
      </div>
    );
  }

  setPopupMessage = msg => {
    this.setState({ infoMessage: msg });
  };

  modalPopupBtnOk_Callback = () => {
    this.setState({ infoMessage: null });
  };

  getPageTitle() {
    if (
      this.props.currentAdminScreenID ===
      AdminScreens.ADMIN_SCREEN_TERMINAL_BALANCE
    ) {
      return "Saldo terminala";
    } else if (
      this.props.currentAdminScreenID === AdminScreens.ADMIN_SCREEN_BILL_FLOW
    ) {
      return "Promet novčanica";
    } else if (
      this.props.currentAdminScreenID === AdminScreens.ADMIN_SCREEN_TRANSACTIONS
    ) {
      return "Povijest transakcija";
    } else if (
      this.props.currentAdminScreenID ===
      AdminScreens.ADMIN_SCREEN_TICKET_OVERVIEW
    ) {
      return "Pregled tiketa";
    } else if (
      this.props.currentAdminScreenID === AdminScreens.ADMIN_SCREEN_QR_CODES
    ) {
      return "Izrada QR kodova";
    } else if (
      this.props.currentAdminScreenID === AdminScreens.ADMIN_SCREEN_SETTINGS
    ) {
      return "Postavke terminala";
    } else if (
      this.props.currentAdminScreenID === AdminScreens.ADMIN_SCREEN_FIND_TICKET
    ) {
      return "Pronalazak tiketa";
    } else if (
      this.props.currentAdminScreenID === AdminScreens.ADMIN_SCREEN_EVENT_LOG
    ) {
      return "Zapisnik događaja";
    } else if (
      this.props.currentAdminScreenID === AdminScreens.ADMIN_SCREEN_DASHBOARD
    ) {
      return "Nadzorna ploča";
    } else if (
      this.props.currentAdminScreenID ===
      AdminScreens.ADMIN_SCREEN_PARTIAL_PAYOUT_RECEIPTS
    ) {
      return "Potvrde za djelomičnu isplatu";
    }

    return "Unknown page...";
  }
}

const mapStateToProps = state => {
  return {
    currentAdminScreenID: state.rrNavigation.currentAdminScreenID,
    isAdminLoadingShown: state.rrNavigation.isAdminLoadingShown
  };
};

export default connect(mapStateToProps)(LayoutAdmin);



// WEBPACK FOOTER //
// ./src/HOCs/LayoutAdmin/LayoutAdmin.js